const DEFAULT_STATE = {
  isLoggedIn: false,
  firstName: '',
  lastName: '',
  email: '',
  id: null,
};

function cloneDefaultState(patch = {}) {
  return { ...DEFAULT_STATE, ...patch };
}

function extractUser(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  if (payload.user && typeof payload.user === 'object') {
    return payload.user;
  }
  return payload;
}

export function createAuthSessionClient({ fetchImpl, getApiBase, getToken } = {}) {
  if (typeof fetchImpl !== 'function' || typeof getApiBase !== 'function') {
    return null;
  }

  const tokenProvider = typeof getToken === 'function' ? getToken : () => null;

  return {
    async checkAuthStatus({ force } = {}) {
      try {
        const apiBase = getApiBase();
        if (!apiBase) {
          return cloneDefaultState();
        }

        const headers = { 'Content-Type': 'application/json' };
        const token = tokenProvider();
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }

        const response = await fetchImpl(`${apiBase}/api/auth/me`, {
          method: 'GET',
          credentials: 'include',
          headers,
        });

        if (response.status === 401 || response.status === 403) {
          return cloneDefaultState();
        }

        if (!response.ok) {
          return cloneDefaultState();
        }

        const payload = await response.json().catch(() => null);
        const user = extractUser(payload);
        if (!user) {
          return cloneDefaultState();
        }

        return cloneDefaultState({
          isLoggedIn: true,
          firstName: typeof user.firstName === 'string' ? user.firstName : '',
          lastName: typeof user.lastName === 'string' ? user.lastName : '',
          email: typeof user.email === 'string' ? user.email : '',
          id: user.id ?? null,
          emailVerified: Boolean(user.email_verified_at ?? user.emailVerified ?? false),
        });
      } catch (error) {
        return cloneDefaultState();
      }
    },
  };
}

if (typeof window !== 'undefined') {
  window.AgileProUtils = window.AgileProUtils || {};
  if (typeof window.AgileProUtils.createAuthSessionClient !== 'function') {
    window.AgileProUtils.createAuthSessionClient = createAuthSessionClient;
  }
}

